module.exports = __webpack_public_path__ + "static/media/test8_4.64e808b8.png";